"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrors = void 0;
const isEqual_1 = __importDefault(require("lodash/isEqual"));
/** Abstract base class for validation errors for one step. */
class ValidationErrors {
    /** Returns if there are any validation errors. */
    hasErrors() {
        return Object.values(this).some((val) => val !== "");
    }
    /** Returns true if this is equals to the other validation errors. */
    equals(other) {
        return (0, isEqual_1.default)(this, other);
    }
}
exports.ValidationErrors = ValidationErrors;
